import React from 'react';
import Form from 'screens/shared/form';
import { _t } from 'utils';

export default ({ filters, setFilters, nodepools }) => {
  const {
    ramRange = [],
    coreRange = [],
    searchText = '',
  } = filters;

  const applyFilters = () => {
    let filteredNodepools = nodepools;
    filteredNodepools = filteredNodepools
      .filter((node) => (
        ((node.properties.ramSize / 1024) >= ramRange[0]
          && (node.properties.ramSize / 1024) <= ramRange[1])
        && (node.properties.coresCount >= coreRange[0]
          && node.properties.coresCount <= coreRange[1])
      ));

    if (searchText) {
      filteredNodepools = filteredNodepools
        .filter((node) => (
          node.properties.name.toLowerCase()
            .indexOf(searchText.toLowerCase()) !== -1));
    }

    return filteredNodepools;
  };

  const setFilter = (values) => {
    setFilters((s) => ({ ...s, ...values }));
  };

  const fields = [
    {
      name: 'searchText',
      onChange: (value) => setFilter({ searchText: value }),
      title: _t('Search'),
      type: 'text',
    },
    {
      name: 'coreRange',
      onChange: (value) => setFilter({ coreRange: value }),
      title: _t('Cores'),
      type: 'range',
      range: [0, 100],
    },
    {
      name: 'ramRange',
      onChange: (value) => setFilter({ ramRange: value }),
      title: _t('RAM'),
      type: 'range',
      range: [0, 100],
    },
  ];

  return ([
    applyFilters(),
    <Form
      fields={fields}
      fieldsValues={filters}
      isActionButtons={false}
    />,
  ]);
};
